var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2a1 1 0 011 1v18a1 1 0 01-1 1H5a1 1 0 01-1-1V11a1 1 0 011-1h6a1 1 0 001-1V3a1 1 0 011-1h6z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.073 5.078a.25.25 0 01.427.177V8.25a.25.25 0 01-.25.25H7.255a.25.25 0 01-.177-.427l2.995-2.995z",
    fill: "currentColor"
  })));
}
SvgFileFilled.displayName = 'FileFilled';
export default SvgFileFilled;